<template>
  <div>
    <headervue></headervue>

    <div class="container" style="text-align: center;margin-top: 12px;">
      <div class="ui medium centered image">
        <img class="ui medium image" src="../assets/logo_Big.jpg" />
        <form v-on:submit.prevent="submitForm">
          <div class="ui placeholder segment">
            <!-- MESSAGES-->
            <div
              v-if="error != ''"
              class="ui message"
              :class="{ warning: error }"
            >
              <div class="header">Error!</div>
              <ul class="list">
                <p>{{ error }}</p>
              </ul>
            </div>

            <div class="ui form">
              <div class="field">
                <div v-if="!hasText" class="ui left icon input">
                  <input
                    v-model="dbName"
                    name="dbName"
                    type="text"
                    class="ui input"
                    placeholder="App Number"
                  />
                  <i class="database icon"></i>
                </div>
              </div>
              <div class="field">
                <div class="ui left icon input">
                  <input
                    v-model="username"
                    name="username"
                    type="text"
                    class="ui input"
                    placeholder="Username"
                  />
                  <i class="user icon"></i>
                </div>
              </div>
              <div class="field">
                <div class="ui left icon input">
                  <input
                    v-model="password"
                    name="password"
                    type="password"
                    class="ui input"
                    placeholder="Password"
                  />
                  <i class="lock icon"></i>
                </div>
              </div>
              <button
                class="ui large primary submit button mb-12"
                type="submit"
              >
                Login
              </button>
              <div class="field">
                <!-- <div class="ui checkbox">
                  <input type="checkbox" tabindex="0" class="hidden" />
                  <label>Remember Me...</label>
                </div> -->
              </div>
              <span>I cannot access my account... HELP</span>
            </div>
          </div>

          <!-- <button class="large ui primary button" >Login</button> -->
        </form>
      </div>
      <div class="ui medium centered"></div>
    </div>
    <!-- <button class="large ui primary button" >Login</button> -->
  </div>
</template>
<script>
import router from "../router/index";
import headervue from "./Header";

export default {
  name: "Login",
  components: {
    headervue
  },
  data() {
    return {
      username: "",
      password: "",
      dbName: "",
      error: "",
      hasText: false
    };
  },
  methods: {
    submitForm() {
      this.axios
        .post(this.$store.state.apiUrl + "/Read/login.php", {
          username: this.username,
          password: this.password,
          dbName: this.dbName
        })
        .then(res => {
          // unshift to push at the beginning of the array
          //this.comments.unshift(res.data[0]);
          if (res.data.error) {
            this.error = res.data.error;
            $(".message").transition("fade down");
            setTimeout(() => {
              this.showError = false;
              $(".message").transition("fade down");
            }, 5000);
          } else {
            //creating token for user
            localStorage.setItem("token", res.data.token);
            this.$store.commit("LOGIN", true);
            router.push("/").catch(err => {});
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  mounted() {
    if (this.$route.params.dbName) {
      console.log(this.dbName);
      this.dbName = this.$route.params.dbName;
      this.hasText = true;
    }
  },
  created() {
    // this.$store.watch(
    //   state => {
    //     return this.$store.state.loggedIn; // could also put a Getter here
    //   },
    //   (newValue, oldValue) => {
    //     //something changed do something
    //     console.log(oldValue);
    //     console.log(newValue);
    //     if (newValue == true) {
    //       router.push("/");
    //     } else {
    //       router.push("login/" + this.dbName);
    //     }
    //   },
    //   //Optional Deep if you need it
    //   {
    //     deep: true
    //   }
    // );
  }
};
</script>
<style>
.toolbar {
  height: 60px;
  margin: -8px;
  display: flex;
  align-items: center;
  background-color: #1976d2;
  color: white;
  font-weight: 600;
}

.toolbar img {
  margin: 0 16px;
}

.toolbar #twitter-logo {
  height: 40px;
  margin: 0 16px;
}

.toolbar #twitter-logo:hover {
  opacity: 0.8;
}
.spacer {
  flex: 1;
}

.mb-12 {
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue